@if (placeholder) {
  <div class="editor">
    @if (isBoxTitle) {
      <button class="secondary clear-text"
              (click)="clearText()">
        <mat-icon svgIcon="clear-text"></mat-icon>
        {{ 'i18n.button.clearText' | translate }}
      </button>
    }

    <div class="menu">
      @if (controls.font) {
        <div class="item"
             [title]="'i18n.control.textEditing.menu.fonts' | translate"
             (click)="switchView('fonts')"
             [ngClass]="{'active': viewMode === 'fonts'}">
          <mat-icon svgIcon="fonts"></mat-icon>
        </div>
      }
      @if (controls.alignment || controls.fontSize) {
        <div class="item"
             [title]="'i18n.control.textEditing.menu.effects' | translate"
             (click)="switchView('effects')"
             [ngClass]="{'active': viewMode === 'effects'}">
          <mat-icon svgIcon="effects"></mat-icon>
        </div>
      }
      @if (controls.color) {
        <div class="item"
             [title]="'i18n.control.textEditing.menu.colors' | translate"
             (click)="switchView('colors')"
             [ngClass]="{'active': viewMode === 'colors'}">
          <mat-icon svgIcon="colors"></mat-icon>
        </div>
        <div class="item"
             [title]="'i18n.control.textEditing.menu.bgColors' | translate"
             (click)="switchView('bg-colors')"
             [ngClass]="{'active': viewMode === 'bg-colors'}">
          <mat-icon svgIcon="bg-colors"></mat-icon>
        </div>
      }
    </div>
    <div class="container">
      @if (viewMode === 'fonts') {
        @if (controls.font) {
          <font-chooser
            [fontName]="this.textModel.fontDescription.name"
            (fontNameChange)="onFontNameChanged($event)"
          ></font-chooser>
        }
      }
      @if (viewMode === 'effects') {
        @if (controls.alignment) {
          <div class="control-box">
            <div class="title">
              Texteffekte
            </div>
            <text-effects-chooser
              [textModel]="textModel"
              (fontVariantChange)="onFontVariantChanged($event)"
              (effectChange)="onEffectChanged($event)"
            >
            </text-effects-chooser>
          </div>
          <div class="control-box">
            <div class="title">
              Ausrichtung
            </div>
            <text-alignment-chooser
              [alignment]="textModel.horizontalAlignment"
              (alignmentChange)="onAlignmentChanged($event)"
            ></text-alignment-chooser>
          </div>
        }
        @if (controls.fontSize) {
          <div class="control-box">
            <div class="title">
              Größe
            </div>
            <text-size-chooser
              [fontSize]="normalizedFontSize"
              [minDisplayFontSize]="minNormalizedFontSize"
              [maxDisplayFontSize]="maxNormalizedFontSize"
              (fontSizeChange)="onFontSizeChanged($event)"
              [enabled]="!isTextEmpty"
            ></text-size-chooser>
          </div>
        }
      }
      @if (viewMode === 'colors') {
        @if (controls.color) {
          <color-chooser
            [currentColor]="textModel.color"
            (currentColorChange)="onColorChanged($event)"
          ></color-chooser>
        }
      }
      @if (viewMode === 'bg-colors') {
          <color-chooser
            [transparentAllowed]="true"
            [appliesToBackground]="true"
            [contrastColor]="textModel.color"
            [currentColor]="textModel.bgColor"
            (currentColorChange)="onBgColorChanged($event)"
          ></color-chooser>
      }
    </div>
  </div>
}
